import { css } from 'styled-system/css';

export const modalStyle = {
	full: css({
		p: 0,
		'& .modal__header': {
			display: 'flex',
			alignItems: 'center',
			height: 'var(--modal-header-height)',
			md: {
				borderBottom: '1px solid {colors.black.5}',
			},
			_mdBelow: {
				bgColor: 'header.containerBg',
			},
		},
		'& .icon--arrow-left': {
			width: '18px',
			height: '18px',
		},
		'& .modal__title': {
			bgColor: 'unset',
			_mdBelow: {
				borderBottom: 'none',
				color: 'whiteOpacity.100',
				p: 0,
				minH: 'unset',
			},
		},
		'& .modal__container': {
			height: '100%',
			maxWidth: 'unset',
			maxHeight: 'unset',
			rounded: 0,
			bgColor: 'var(--s800)',
			md: {
				maxWidth: '600px',
				maxHeight: 'calc(100vh - 60px)',
				rounded: '6px',
			},
		},
		'& .modal__body': {
			p: 0,
			maxH: 'calc(100% - var(--modal-header-height))',
			display: 'flex',
			flexDirection: 'column',
		},
		'& .modal__close-btn': {
			top: '6px',
			_mdBelow: {
				display: 'none',
			},
			'& .btn--icon': {
				color: 'black.3',
			},
		},
	}),
	marsModal: css({
		_mars: {
			// '& .modal__title': {
			// 	bgColor: 'modal.title.bg',
			// },
		}
	}),
	backButton: css({
		_mars: {
			color: 'whiteOpacity.100',
			md: {
				display: 'none',
			}
		}
	}),
};